import ServiceHouseFields from './ServiceHouseFields';

export default ServiceHouseFields;
